import { render } from "./BeneficiaryDetails.vue?vue&type=template&id=f167cffa&scoped=true"
import script from "./BeneficiaryDetails.vue?vue&type=script&lang=js"
export * from "./BeneficiaryDetails.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=f167cffa&scoped=true&lang=css&external"
import "./BeneficiaryDetails.vue?vue&type=style&index=1&id=f167cffa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f167cffa"]])

export default __exports__